import type React from 'react';
import type { CSSProperties } from 'react';

import clsx from 'clsx';

import type { Partner } from '../model/domain/Partner';

import AppConfig from './../AppConfig';

export interface PartnerLogoProps {
  partner: Partner;
  style?: CSSProperties;
}

const PartnerLogo: React.FC<PartnerLogoProps> = ({ partner, style }) => {
  return (
    <div className={clsx(style)}>
      <a className="flex h-full w-full items-center justify-center" href={partner.url} tabIndex={-1} target="blank">
        <img
          alt="Logo of the partner"
          className="max-h-[23px] max-w-[200px] pr-[54px]"
          src={`${AppConfig.apiUrl}/app/media/${partner.logoId}`}
        />
      </a>
    </div>
  );
};

export default PartnerLogo;
